import styled from 'styled-components'

export const BannerContainer = styled.div`
  background: radial-gradient(
    circle at 50% -220%,
    var(--light4),
    var(--light4) 90%,
    var(--light) 90%
  );

  padding-top: 2rem;
  height: 650px;

  @media (max-width: 700px) {
    height: auto;
  }
`
